import _ from 'lodash'
import { createSelector } from 'reselect'
import { getActiveServerId } from '../activeServer/selectors'

export const getProcesses = state => state.backendReducer.process || {}
// const getProcessesForServer = (state, serverId) => {
//     const processes = getProcesses(state)
//     return processes[serverId] || {}
// }
// const getProcess = (state, serverId, userId) => {
//     const serverProcesses = getProcessesForServer(state, serverId)
//     return serverProcesses[userId] || false
// }

const getActiveProcesses = createSelector(
    [getActiveServerId, getProcesses],
    (active, processes) => processes[active] || {},
)
export const getActiveProcess = (state, userId) => {
    const processes = getActiveProcesses(state)
    return processes[userId] || false
}

// Given a list of processes, turn into array of
// userIds, containing only ids of running processes
const reduceToRunning = (processes) => {
    if (_.isEmpty(processes)) return []
    return _.reduce(
        processes,
        (result, isRunning, userId) => {
            if (isRunning) result.push(userId)
            return result
        },
        [],
    )
}

// This gives me a list of names of processes that are running per server
export const getRunningProcesses = createSelector([getProcesses], (processes) => {
    if (_.isEmpty(processes)) return {}
    return _.reduce(
        processes,
        (result, serverProcesses, serverId) => {
            result[serverId] = reduceToRunning(serverProcesses)
            return result
        },
        {},
    )
})
export const getActiveRunningProcesses = createSelector(
    [getRunningProcesses, getActiveServerId],
    (processes, serverId) => processes[serverId] || [],
)



// WEBPACK FOOTER //
// ./src/features/Backend/data/process/selectors.js